import { ReactComponent as NewPlace } from 'assets/newPlace.svg'
import { ReactComponent as Location } from 'assets/location.svg'
import { selectPlaces, updateMapOption } from '../Map/mapSlice'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'

const FindPlacePopup = () => {
  const places = useSelector(selectPlaces)

  const { goBack, push } = useHistory()
  const { t } = useTranslation('map')
  const dispatch = useDispatch()

  return (
    <Popup
      centered
      isLine={false}>

      <div className='popup--findPlace'>
        <div className='popup__header'>
          <div>{t('weCouldNotFindMagInTheSelectedLocation-array')[0]}</div>
          <div>{t('weCouldNotFindMagInTheSelectedLocation-array')[1]}</div>
        </div>

        {places?.length > 0 && <p>{t('nearestWarehouses')}:</p>}

        <div className='popup__places center'>
          {[...places]
            .sort((a, b) => a?.distance - b?.distance)
            .slice(0, 2)
            .map(({ id, gpslatitude, gpslongitude, street = '', estateNumber = '', city, distance, zip }, idx) => {
              const showPlace = () => {
                if (!id) return
                goBack()
                if (gpslatitude && gpslongitude) dispatch(updateMapOption({
                  mapPosition: [gpslatitude, gpslongitude],
                  zoom: 12
                }))
                setTimeout(() => push(`/map/${id}`))
              }

              return <div
                key={idx}
                className='places__item'>
                <div className='item__label'>{distance}km {t('fromYou')}</div>
                <div className='group'>
                  <div className='item__address'>
                    <span>{zip} {city}, {street} {estateNumber}</span>
                  </div>
                  <div className='item__icon' onClick={showPlace}>
                    <Location />
                  </div>
                </div>
              </div>
            })}
        </div>

        <div className='popup__footer center'>
          <p>{t('magCloserToYou')}</p>

          <button
            className='button --arrow --enlarged'
            onClick={() => push(window.location.pathname, LOCATION_STATES.popup('newplace'))}>
            <NewPlace />
            <span className='--secFont'>{t('reportThisLocation')}</span>
          </button>

          <BackBtn text={t('close')} />
        </div>
      </div>
    </Popup>
  )
}

export default FindPlacePopup